<template>
  <div id="editor" class="container frontpage-editor">
    <div class="header row">
      <div class="col"></div>
      <div class="col-auto">
        <input id="run_at" v-model="run_at" class="form-control" name="run_at" step="1"
               type="datetime-local"/>
      </div>
      <div class="button-container col-auto">
        <button class="btn btn-dark float-right" @click="save">
          {{ (dateInFuture(run_at) ? (update ? 'Update ' : '') + 'Schedule' : 'Publish now') }}
        </button>
        <div class="notification">{{ notification }}</div>
      </div>
    </div>
    <hero-module
        :collections="types.collection_snicks.variants || []"
        :data="hero"
        :extraHeroes="extraHeroes"
        :image_path="image_path"
        :stories="stories"
        :update="update"
        @update-hero-collection="updateHero('collection_id', $event)"
        @update-hero-snick="updateHero('story_id', $event)"
        @update-hero-link-type="updateHero('link_type', $event)"
        @update-hero-image="updateHero('image-data', $event)"
        @add-extra-hero="addExtraHero($event)"
        @remove-extra-hero="removeExtraHero($event)"
    />

    <div class="container-fluid module">
      <div class="h3">Modules</div>
      <table class="table border-bottom mb-5">
        <thead class="thead-light">
        <tr>
          <th class="compact">#</th>
          <th>{{ $t('headings.sections') }}</th>
          <th>{{ $t('headings.dates') }}</th>
          <th>{{ $t('headings.Shuffling') }}</th>
          <th>{{ $t('headings.displayType') }}</th>
          <th>{{ $t('headings.imageSize') }}</th>

          <th class="compact">{{ $t('headings.actions') }}</th>
        </tr>
        </thead>
        <draggable
            v-model="modules"
            :options="{ handle: '.drag-handle' }"
            class="modules"
            element="tbody"
            @end="drag=false"
            @start="drag=true"
        >
          <generic-module
              v-for="(module, index) in modules"
              :key="`module-${index}`"
              :bannerImage="module.params.banner_image"
              :deleteBtnText="$t('interface.btnDelete')"
              :displayTypes="displayTypes"
              :imageSize="module.params.image_size"
              :index="getIndex(index)"
              :label="module ? module.label : ''"
              :selectedDates="module.params.publication_dates"
              :selectedDisplayType="module.params.display_type"
              :shuffling="module.params.shuffling"
              :variant="module ? module.variant : { id: null }"
              @changeCollection="changeCollection($event, index)"
              @changeDates="changeDates($event, index)"
              @delete="deleteModule(index)"
          ></generic-module>
          <tr v-if="isEmptyList">
            <td class="text-center" colspan="3">{{ $t('messages.noModulesAdded') }}</td>
          </tr>
        </draggable>
      </table>
      <div class="row">
        <div class="col">
          <label>{{ $t('headings.selectModule') }}</label>
          <select ref="type" class="custom-select form-control" v-on:change="selectType($event)">
            <option v-for="(type, index) in types" :key="index" :value="index">{{ type.label }}</option>
          </select>
        </div>
        <div class="col">
          <label>
            {{
              isVariantsDisabled
                  ? $t('headings.variants')
                  : $t('headings.select') + ' ' + type.label
            }}
          </label>
          <select
              ref="variant"
              class="custom-select form-control"
              v-bind:disabled="isVariantsDisabled"
          >
            <option v-for="(variant, index) in type.variants || []" :key="index">{{ variant.name }}</option>
            <option v-if="isVariantsDisabled">{{ $t('messages.noVariants') }}</option>
          </select>
        </div>
        <div class="col d-flex align-items-end">
          <button class="btn btn-dark" @click="addModule($event)">{{ $t('interface.btnAdd') }}</button>
        </div>
      </div>
    </div>

    <div class="container-fluid module">
      <div class="h3">Scheduled changes</div>
      <table class="table table-sm border-bottom mb-5">
        <thead class="thead-light">
        <tr>
          <th class="compact">#</th>
          <th>Publish at date</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="change in scheduled_changes" v-bind:key="change.id"
            :class="{'table-active': isCurrentUpdate(change.id), 'table-danger': !dateInFuture(change.run_at)}">
          <td><a :href="'/startpage/'+change.id" class="btn">{{ change.id }}</a></td>
          <td><a :href="'/startpage/'+change.id" class="btn">{{ change.run_at }}</a></td>
          <td class="text-right">
            <button class="btn btn-danger" @click="deleteChange(change.id)">Delete</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import GenericModule from "./GenericModule";
import HeroModule from "./HeroModule";
import moment from "moment";

export default {
  props: {
    posts: Array,
    stories: Array,
    types: Object,
    hero_data: Object,
    extra_heroes_data: Array,
    image_path: String,
    update: Object
  },
  components: {
    GenericModule,
    HeroModule,
    draggable,
  },
  beforeMount() {
    this.getScheduledChanges();
    setInterval(this.getScheduledChanges, 10000);
  },
  methods: {
    save() {
      if (typeof this.hero['image-data'] === 'undefined' && typeof this.hero['image'] === 'undefined') {
        alert('You need to select a new hero image.'
            + '\nThe displayed image is there just to verify the current version. ');
        return false;
      }
      if (this.extra_heroes_data.length > 0) {
        for (let i = 0; i < this.extra_heroes_data.length; i++) {
          if (typeof this.extra_heroes_data[i]['image-data'] === 'undefined' && typeof this.extra_heroes_data[i]['image'] === 'undefined') {
            alert('You need to select a new hero image.'
                + '\nThe displayed image is there just to verify the current version. ');
            return false;
          }
        }
      }

      // Prepare request
      const url = (this.update ? '/startpage/' + this.update.id : '/startpage');
      const data = {
        modules: this.modules,
        hero: this.hero,
        extra_heroes: this.extra_heroes_data,
        runAtDate: this.run_at
      };
      // Post data to controller

      console.debug('Saving data to ' + url, data);
      axios
          .post(url, data)
          .then((response) => {
            const posts = response.data;

            this.modules = this.parsePosts(posts);

            this.getScheduledChanges();
            this.notification = "✓ " + this.$t("messages.saved");
            setTimeout(() => {
              this.notification = null;
            }, 1500);
          })
          .catch((error) => {
            console.error(error);
          });
    },

    getScheduledChanges() {
      axios
          .get('/startpage/scheduled_changes')
          .then((changes) => {
            this.scheduled_changes = changes.data;
          })
          .catch((error) => {
            console.error(error);
          });
    },

    // Process module data
    parsePosts(posts) {
      return posts.map((entry) => this.parseSinglePost(entry));
    },

    // Process single module (Validate and normalize)
    parseSinglePost(entry) {
      const type = this.getType(entry);

      entry.label = type.label || "Unkown data type";
      entry.params = this.parseParams(entry.params || {}, type.label);
      return entry;
    },

    // Process module parameters (Validate and normalize)
    parseParams(params, label) {
      params.image_size = params.image_size || "small";
      if (label === "Collection") {
        params.display_type = params.display_type || "Snicks list";
      }
      const hasDates =
          params.publication_dates &&
          params.publication_dates.start &&
          params.publication_dates.end;
      params.publication_dates = hasDates ? params.publication_dates : null;

      return params;
    },

    getIndex(index) {
      var padSize = this.modules.length.toString().length;
      if (padSize === 1) padSize++;

      return (index + 1).toString().padStart(padSize, 0);
    },
    getType(entry) {
      return this.types[entry.module] || {};
    },
    selectType(event) {
      const type = this.types[event.srcElement.value];
      this.type = type || {};
    },
    addModule(event) {
      const index = this.$refs.variant.selectedIndex;
      const variant = this.type.variants
          ? this.type.variants[index]
          : {id: null};

      this.modules.push(
          this.parseSinglePost({
            label: this.type.label,
            module: this.$refs.type.value,
            foreign_key: variant.id,
            variant,
          })
      );
    },

    // Event handler: A user deletes a module
    deleteModule(index) {
      if (!confirm(this.$t("messages.confirmDeleteModule"))) return false;
      this.modules.splice(index, 1);
    },

    // Event handler: A new image size has been chosen for a module
    changeCollection(event, index) {
      const module = this.modules[index];
      var value = event.target.value;
      var paramName = event.target.id.split("-")[2];

      if (paramName === "shuffling") {
        value = event.target.checked.toString();
      }

      this.$set(module.params, paramName, value);
    },

    changeShuffle(size, index) {
      const module = this.modules[index];
      module.params.test = size;
    },

    // Event handler: Date range for publication has been set/updated
    changeDates(payload, index) {
      const module = this.modules[index];

      if (!payload.date && module.params.publication_dates) {
        delete module.params.publication_dates;
        return;
      }

      module.params["publication_dates"] = {
        start:
            moment(payload.date.start).format("YYYY-MM-DD") +
            " " +
            payload.time.start,
        end:
            moment(payload.date.end).format("YYYY-MM-DD") +
            " " +
            payload.time.end,
      };
    },
    // Event handler: A new collection, snick or image has been chosen for the hero
    updateHero(field, data) {
      if (data.extraHeroIndex !== null) {
        this.extra_heroes_data[data.extraHeroIndex][field] = data.value;
        return;
      }
      this.hero[field] = data.value;
    },
    addExtraHero(data) {
      this.extra_heroes_data.push(data);
    },
    removeExtraHero(params) {
      const {index, hero} = params;
      this.extra_heroes_data.splice(index, 1);
    },

    isCurrentUpdate(id) {
      return (this.update && this.update.id === id);
    },
    dateInFuture(date) {
      return (moment().diff(date) < 0);
    },
    deleteChange(id) {
      if (confirm('Are you sure you wish to remove the scheduled update')) {
        console.debug('DELETE');
        axios
            .delete('/startpage/' + id)
            .then((response) => {
              if (this.update && response.data === this.update.id) {
                window.location.replace('/startpage');
              } else {
                this.getScheduledChanges();
              }
            })
            .catch((error) => {
              console.error(error);
            });
      }
    }
  },
  data: function () {
    let data = {
      modules: this.parsePosts(this.posts) || [],
      hero: this.hero_data,
      extraHeroes: this.extra_heroes_data,
      type: {},
      notification: null,
      displayTypes: [
        {value: "Snicks list", label: "Snicks list"},
        {value: "Large banner", label: "Large banner (w: 670px, h: 670px)"},
        {value: "Small banner", label: "Small banner (w: 670px, h: 320px)"},
      ],
      run_at: (this.update ? this.update.run_at : moment().format('yyyy-MM-DD\Thh:mm:ss')),
      scheduled_changes: []
    };
    return data;
  },
  computed: {
    isEmptyList: function () {
      return this.modules.length === 0;
    },
    isVariantsDisabled: function () {
      if (!this.type) return true;
      if (!this.type.variants) return true;
      return this.type.variants.length === 0;
    },
  },
  i18n: {
    locale: "en",
    messages: {
      en: {
        interface: {
          btnAdd: "Add",
          btnSave: "Save",
          btnDelete: "Delete",
        },
        headings: {
          sections: "Sections",
          actions: "Actions",
          selectModule: "Select Module",
          select: "Select",
          variants: "Variants",
          imageSize: "Image Size",
          Shuffling: "Shuffle",
          displayType: "Display type",
          dates: "Publication dates",
        },
        messages: {
          confirmDeleteModule: "Are you sure you want to remove the section?",
          noModulesAdded: "No sections added yet.",
          noVariants: "No variants",
          saved: "Saved",
        },
      },
      sv: {
        interface: {
          btnAdd: "Lägg till",
          btnSave: "Spara",
          btnDelete: "Ta bort",
        },
        headings: {
          sections: "Sektioner",
          actions: "Kommandon",
          selectModule: "Välj modul",
          select: "Välj",
          variants: "Varianter",
          imageSize: "Bildstorlek",
          displayType: "Visningstyp",
          dates: "Publiceringsdatum",
        },
        messages: {
          confirmDeleteModule: "Är du säker på att du vill ta bort sektionen?",
          noModulesAdded: "Inga sektioner har lagts till än.",
          noVariants: "Inga varianter",
          saved: "Sparad",
        },
      },
    },
  },
};
</script>
